import React from "react";

const Quiz = () => {
  return (
    <div style={styles.container}>
      <h1>🧠 Quiz Page</h1>
      <p>This is where users will test their reading comprehension.</p>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0f0f0f",
    color: "#ffffff",
    padding: "2rem",
    textAlign: "center",
  },
};

export default Quiz;
